export default __webpack_public_path__ + "da4a57ce64f2052bcb704450c5c51c72.png";